<template>
  <div class="flex flex-col gap-4">
    <div class="flex h-52 break-inside-avoid flex-row gap-4">
      <div class="flex min-w-0 grow flex-col">
        <h3 class="text-title-medium">Verlauf</h3>
        <div class="relative grow px-2">
          <div class="absolute top-0 left-0 z-0 flex h-full w-full flex-col justify-between pb-6">
            <div
              v-for="_ in scale.items"
              class="border-t-surface-container-highest w-full border-t"
            ></div>
          </div>
          <div class="relative z-10 flex h-full flex-row justify-end">
            <div
              v-for="progressPoint in progress"
              :key="progressPoint.date"
              class="flex h-full w-10 flex-col items-center"
            >
              <div class="flex grow flex-col justify-end">
                <div
                  class="bg-primary-container border-primary flex min-h-2 w-7 flex-col items-center rounded-full border p-1"
                  :style="{ height: 100 * progressPoint.average + '%' }"
                >
                  <BaseShape
                    v-if="progressPoint.average >= 0.8"
                    class="text-on-primary-container"
                    shape="burst"
                  />
                  <div v-else class="bg-on-primary-container mt-1 h-1.5 w-1.5 rounded-full"></div>
                </div>
              </div>
              <div class="h-6">
                <span class="text-label-small text-on-surface-variant text-center">
                  {{
                    useDisplayDate(progressPoint.date, {
                      dayName: 'none',
                      monthName: 'number',
                      year: 'none',
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="latestValue" class="flex break-inside-avoid flex-row gap-4">
      <div class="flex w-full flex-col gap-0.5">
        <div class="flex flex-row items-center">
          <h3 class="text-title-medium grow">Letzte Antworten</h3>
          <span class="text-label-large text-on-surface-variant">{{
            useDisplayDate(latestValue.date)
          }}</span>
        </div>
        <div
          class="rounded-small border-outline-variant divide-outline-variant flex break-inside-avoid flex-col divide-y border"
        >
          <div v-for="question in questionsWithFeedbacks" class="px-3 py-2">
            <div class="flex flex-row items-center gap-0.5">
              <span class="text-body-medium grow pr-2">
                {{ question.text }}
              </span>

              <div
                class="bg-surface-container-highest flex w-40 shrink-0 flex-row overflow-hidden rounded-full"
              >
                <div
                  v-if="question.feedback != undefined"
                  class="rounded-extra-small bg-primary h-6 min-w-2"
                  :style="{ width: question.feedback * 100 + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import type { Scale } from '@/core/models/scale'
  interface Props {
    feedbackTopic: {
      id: string
      title: string
      icon: string
    }
    latestValue?: {
      date: string
      average: number | null
      feedbacks: ReadonlyArray<{
        questionId: string
        value: number | null
      }>
    }
    progress: ReadonlyArray<{
      date: string
      average: number
    }>
    questions: ReadonlyArray<{
      id: string
      text: string
    }>
    scale: Scale
  }

  const props = defineProps<Props>()

  const questionsWithFeedbacks = computed(() => {
    const result = []
    for (const question of props.questions) {
      const feedback = props.latestValue?.feedbacks.find(
        (feedback) => feedback.questionId == question.id,
      )

      result.push({
        id: question.id,
        text: question.text,
        feedback: feedback?.value,
      })
    }

    return result
  })
</script>
